


















import { defineComponent, computed } from '@nuxtjs/composition-api';
import { SfRadio } from '@storefront-ui/vue';

export default defineComponent({
  name: 'RadioButton',
  components: {
    SfRadio
  },
  props: {
    model: {
      type: String,
      default: ''
    },
    update: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: String,
      default: ''
    },
    name: { type: String, default: '' },
    value: { type: String || Number, default: '' },
    sendPointerEvents: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const localModelValue = computed({
      get() {
        return props.model;
      },
      set(newValue) {
        emit('update', newValue);
      }
    });

    return {
      handleChange(e) {
        if (!props.sendPointerEvents && typeof e !== 'string') return;
        emit('update', e);
      },
      localModelValue
    };
  }
});
